import React, { useEffect, useState } from 'react'
import './Testimonials.css'
import { testimonialsQuery } from '../../sanity/queries.js';
import { sanityClient, urlFor } from "../../sanity/client";
import { motion } from 'framer-motion'
import leftArrow from "../../assets/leftArrow.png";
import rightArrow from "../../assets/rightArrow.png";

const Testimonials = () => {
    const transition = {type: "spring", duration: "3"};
    const [selected, setSelected] = useState(0);
    const [data, setData] = useState(null);

    useEffect(()=>{
      sanityClient.fetch(testimonialsQuery).then(setData);
    },[])

    if (!data || data.isVisible === false) return null;
    if (!data.testimonials?.length) return null;
    
    const testimonials = data.testimonials;
    const tLength = testimonials.length;

    return (
      <div className="testimonials">
        <div className="left-t">
          <span>{data.title}</span>
          <span className="stroke-text">{data.subtitle.strokeText} </span>
          <span>{data.subtitle.normalText}</span>
          <motion.span
          key={selected}
          initial= {{ opacity: 0, x: -100}}
          animate={{opacity: 1, x:0}}
          exit={{opacity: 0, x:100}}
          transition={transition}
          >
            <span className="quote">“</span>
            {testimonials[selected].review}
            <span className="quote">”</span>
          </motion.span>
          <span>
            <span className="tName">{testimonials[selected].name}</span> -{" "}
            {testimonials[selected].status}
          </span>
        </div>

        <div className="right-t">
          <motion.div
            initial={{opacity: 0, x: -100}}
            transition={{ ...transition, duration: 2}}
            whileInView={{opacity: 1, x: 0}}
          ></motion.div>
          <motion.div
          initial = {{ opacity: 0, x:100}}
          transition={{...transition, duration: 2}}
          whileInView={{ opacity: 1, x:0}}
          ></motion.div>
          <motion.img 
          key= {selected}
          initial={{opacity: 0, x: 100}}
          animate={{opacity: 1, x: 0}}
          exit={{opacity: 0, x: -100}}
          transition={transition}
          src={urlFor(testimonials[selected].image)} alt={testimonials[selected].name} />
          <div className="arrows">
            <img
              onClick={() => {
                selected === 0
                  ? setSelected(tLength - 1)
                  : setSelected((prev) => prev - 1);
              }}
              src={leftArrow}
              alt=""
            />
            <img
              onClick={() => {
                selected === tLength - 1
                  ? setSelected(0)
                  : setSelected((prev) => prev + 1);
              }}
              src={rightArrow }
              alt=""
            />
          </div>
        </div>
      </div>
    );
}

export default Testimonials